import { selectDrawerUser } from "@root/store/selectors/admin/app";
import { selectIsAdminProfile } from "@root/store/selectors/admin/user";
import {
  adminDeleteAdmin,
  adminMakeAdmin,
} from "@root/store/thunks/admin/auth";
import { USER_TYPES } from "@root/constants";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

function useAdmin(props: any) {
  const { t } = useTranslation("common");
  const adminProfile: any = useSelector(selectIsAdminProfile);
  const drawerUser: any = useSelector(selectDrawerUser);
  const [makeAdminPopup, setMakeAdminPopup] = useState(false);
  const [performingAdminAction, setPerformingAdminAction] = useState(false);
  const dispatch = useDispatch();
  const { onAdminClosePopup } = props;

  const makeOrRemoveAdminHandler = () => {
    if (drawerUser?.id) {
      if (drawerUser?.roleId) {
        // MAKE ADMIN HANDLER
        switch (drawerUser?.roleId) {
          case 1:
            setPerformingAdminAction(true);
            const data = {
              payload: {
                email: drawerUser?.email,
                fullname: drawerUser?.fullname,
                username: drawerUser?.username || "",
                roleId: 2,
              },
              onSuccess: () => {
                if (onAdminClosePopup) {
                  onAdminClosePopup();
                }
                setPerformingAdminAction(false);
                setMakeAdminPopup(false);
              },
              onError: () => {
                setPerformingAdminAction(false);
                setMakeAdminPopup(false);
              },
            };
            dispatch(adminMakeAdmin(data));

            break;

          // REMOVE ADMIN HANDLER
          case 2:
          case USER_TYPES.ORGANIZATION_ADMIN:
            setPerformingAdminAction(true);
            const data2 = {
              adminId: drawerUser?.id,
              onSuccess: () => {
                if (onAdminClosePopup) {
                  onAdminClosePopup();
                }
                setPerformingAdminAction(false);
              },
              onError: () => {
                setPerformingAdminAction(false);
              },
            };
            dispatch(adminDeleteAdmin(data2));
            break;

          default:
            break;
        }
      }
    }
  };

  return {
    translate: t,
    admin: adminProfile?.user,
    makeAdminPopup,
    setMakeAdminPopup,
    makeOrRemoveAdminHandler,
    performingAdminAction,
    drawerUser,
  };
}

export default useAdmin;
